<template>
  <div>
    <Message v-if="msg" :msg="msg" />
    <div>
      <form id="burger-form" @submit="createOrder">
        <div class="input-container">
          <label for="name" class="label-style">Nome do Cliente:</label>
          <input
            type="text"
            id="name"
            name="name"
            v-model="name"
            placeholder="Digite seu nome"
            required
          />
        </div>

        <div class="input-container">
          <label for="bread" class="label-style">Escolha o pão:</label>
          <select name="bread" id="bread" v-model="bread" required>
            <option value="">Selecione o seu pão</option>
            <option v-for="bread in breads" :key="bread.id" :value="bread.tipo">
              {{ bread.tipo }}
            </option>
          </select>
        </div>

        <div class="input-container">
          <label for="meat" class="label-style"
            >Escolha o carne do seu Burger:</label
          >
          <select name="meat" id="meat" v-model="meat" required>
            <option value="">Selecione a sua carne</option>
            <option v-for="meat in meats" :key="meat.id" :value="meat.tipo">
              {{ meat.tipo }}
            </option>
          </select>
        </div>

        <div id="opcionais-container" class="input-container">
          <label class="label-style">Selecione os opcionais:</label>
          <div
            class="checkbox-container"
            v-for="optional in optionalData"
            :key="optional.id"
          >
            <label style="cursor: pointer">
              <input
                type="checkbox"
                name="optional"
                v-model="optionals"
                :value="optional.tipo"
              />
              <span>{{ optional.tipo }}</span>
            </label>
          </div>
        </div>

        <div class="input-container">
          <input
            type="submit"
            class="submit-button"
            value="Criar meu Burger!"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Message from "./Message.vue";

export default {
  name: "BurgerForm",
  components: {
    Message,
  },
  data() {
    return {
      breads: null,
      meats: null,
      optionalData: null,
      name: null,
      bread: null,
      meat: null,
      optionals: [],
      msg: null,
    };
  },
  methods: {
    async getIngredients() {
      const req = await fetch("http://localhost:3000/ingredientes");
      const data = await req.json();

      this.breads = data.paes;
      this.meats = data.carnes;
      this.optionalData = data.opcionais;
    },

    async createOrder(e) {
      e.preventDefault();

      const data = {
        name: this.name,
        bread: this.bread,
        meat: this.meat,
        optionals: Array.from(this.optionals),
        status: "Solicitado",
      };

      const req = await fetch("http://localhost:3000/burgers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const res = await req.json();
      console.log(res);

      this.msg = `Pedido de ${res.name} realizado com sucesso!`;

      this.name = "";
      this.bread = "";
      this.meat = "";
      this.optionals = [];
      setTimeout(() => {
        this.msg = "";
      }, 3000);
    },
  },
  mounted() {
    this.getIngredients();
  },
};
</script>

<style scoped>
#burger-form {
  max-width: 400px;
  margin: 0 auto;
}

.input-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.label-style {
  font-weight: bold;
  margin-bottom: 15px;
  color: #222;
  padding: 5px 10px;
  border-left: 4px solid #fcba03;
}

input,
select {
  padding: 5px 10px;
  width: 300px;
  cursor: pointer;
}

#opcionais-title,
#opcionais-container {
  flex-direction: row;
  flex-wrap: wrap;
}

#opcionais-title {
  width: 100%;
}

.checkbox-container {
  display: flex;
  align-items: flex-start;
  width: 50%;
  margin-bottom: 20px;
}

.checkbox-container span,
.checkbox-container input {
  width: auto;
}

.checkbox-container span {
  margin-left: 6px;
  font-weight: bold;
}

.submit-btn {
  background-color: #222;
  color: #fcba03;
  font-weight: bold;
  border: 2px solid #222;
  padding: 10px;
  font-size: 16px;
  margin: 0 auto;
  cursor: pointer;
  transition: 0.5s;
}

.submit-btn:hover {
  background-color: transparent;
  color: #222;
}
</style>
